module.exports = __webpack_public_path__ + "static/media/MTM_ICON.6c6f7ae7.svg";